import { InviteMembers } from '@/features/invites/components/invite-members';
import { useAuth } from '@/hooks/auth/use-auth';
import { MembershipRole } from '@/types/api/membership';

export function Underage() {
  const { context } = useAuth();

  return (
    <section className="grow mb-5 p-6 space-y-6">
      <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-2 flex items-center gap-2">
        🔞 Utbetalning ej tillgänglig
      </h2>

      <p className="text-sm">
        Eftersom du är under 18 år får du inte hantera gruppens utbetalningskonton. En myndig gruppledare kan göra det
        åt er.
      </p>

      <div className="flex flex-col md:flex-row">
        <InviteMembers roles={[MembershipRole.Leader, MembershipRole.Member]} orgId={context!.groupId}>
          Bjud in myndig gruppledare
        </InviteMembers>
      </div>
    </section>
  );
}
